import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles, ThemeProvider } from '@material-ui/core/styles';
import dayjs from 'dayjs';
import Box from '@material-ui/core/Box';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Close from '@material-ui/icons/Close';
import { HyreTheme } from '../../../themes/HyreTheme.js';
import { TimePick } from '../TimePick/TimePick.js';
import { Header } from '../Header/Header.js';
import { AssignSelect } from '../AssignSelect/AssignSelect.js';
var Title = withStyles({
  root: {
    '& h2': {
      display: 'flex',
      'justify-content': 'space-between',
      '& button': {
        'align-self': 'start',
        padding: '0'
      }
    }
  }
})(DialogTitle);
var SubmitActions = withStyles({
  root: {
    justifyContent: 'center'
  }
})(DialogActions);
var PositionSelector = withStyles({
  root: {}
})(Select);
var DepartmentSelector = withStyles({
  root: {}
})(Select);

function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = _objectWithoutProperties(props, ["children", "value", "index"]);

  return /*#__PURE__*/React.createElement("div", Object.assign({
    role: "tabpanel",
    hidden: value !== index,
    id: "wrapped-tabpanel-".concat(index),
    "aria-labelledby": "wrapped-tab-".concat(index)
  }, other), value === index && /*#__PURE__*/React.createElement(Box, {
    sx: {
      p: 3
    }
  }, children));
}

var staffPositionsForDepartment = function staffPositionsForDepartment(positionTypes, departmentID) {
  if (positionTypes && positionTypes.length > 0 && departmentID !== 0) {
    return positionTypes.filter(function (posType) {
      return posType.department.id === departmentID;
    }).map(function (posType) {
      return posType.positionType;
    });
  }

  return [];
};

var ShiftDialog = function ShiftDialog(_ref) {
  var toDate = _ref.toDate,
      user = _ref.user,
      positionTypes = _ref.positionTypes,
      createShift = _ref.createShift,
      open = _ref.open,
      departments = _ref.departments,
      initial = _ref.initial;
  var initialStartTime = dayjs(toDate).hour(8).startOf('hour');
  var initialEndTime = initialStartTime.add(4, 'hours');

  var _useState = useState(initialStartTime),
      _useState2 = _slicedToArray(_useState, 2),
      startTime = _useState2[0],
      setStartTime = _useState2[1];

  var _useState3 = useState(initialEndTime),
      _useState4 = _slicedToArray(_useState3, 2),
      endTime = _useState4[0],
      setEndTime = _useState4[1];

  var _useState5 = useState(9),
      _useState6 = _slicedToArray(_useState5, 2),
      pickedHour = _useState6[0],
      setPickedHour = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      pickedMinutes = _useState8[0],
      setPickedMinutes = _useState8[1];

  var _useState9 = useState(5),
      _useState10 = _slicedToArray(_useState9, 2),
      pickedEndHour = _useState10[0],
      setPickedEndHour = _useState10[1];

  var _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      pickedEndMinutes = _useState12[0],
      setPickedEndMinutes = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      positions = _useState14[0],
      setPositions = _useState14[1];

  var _useState15 = useState(0),
      _useState16 = _slicedToArray(_useState15, 2),
      position = _useState16[0],
      setPosition = _useState16[1];

  var _useState17 = useState(0),
      _useState18 = _slicedToArray(_useState17, 2),
      chosenDepartmentId = _useState18[0],
      setchosenDepartmentId = _useState18[1];

  var _useState19 = useState('assign'),
      _useState20 = _slicedToArray(_useState19, 2),
      assign = _useState20[0],
      setAssign = _useState20[1];

  var _useState21 = useState('Shift'),
      _useState22 = _slicedToArray(_useState21, 2),
      activeTab = _useState22[0],
      setActiveTab = _useState22[1];

  var avatar = user.avatar;

  var _useState23 = useState(initial || false),
      _useState24 = _slicedToArray(_useState23, 2),
      isShown = _useState24[0],
      setIsShown = _useState24[1];

  var hide = function hide() {
    return setIsShown(false);
  };

  var show = function show() {
    return setIsShown(true);
  };

  useEffect(function () {
    setStartTime(dayjs(toDate).hour(pickedHour).minute(pickedMinutes));
  }, [pickedHour, pickedMinutes]);
  useEffect(function () {
    setEndTime(dayjs(toDate).hour(pickedEndHour).minute(pickedEndMinutes));
  }, [pickedEndHour, pickedEndMinutes]);
  useEffect(function () {
    setPositions(staffPositionsForDepartment(positionTypes, chosenDepartmentId));
  }, [chosenDepartmentId, positionTypes]);
  useEffect(function () {
    if (departments && departments.length > 0) {
      setchosenDepartmentId(departments[0].id);
    }
  }, [departments]);
  useEffect(function () {
    if (positions && positions.length > 0) {
      setPosition(positions[0].id);
    }
  }, [positions]);

  var handleSubmit = function handleSubmit(_ref2) {
    var published = _ref2.published;
    createShift({
      startTime: startTime,
      endTime: endTime,
      user: user,
      position: position,
      published: published,
      chosenDepartmentId: chosenDepartmentId,
      assign: assign
    });
    hide();
  };

  var positionsUnAvailable = function positionsUnAvailable() {
    return !positions || !positions.length || positions.length < 1;
  };

  var hoursInShift = endTime > startTime ? endTime.diff(startTime, 'hours', true).toPrecision(3) : startTime.diff(endTime, 'hours');
  return /*#__PURE__*/React.createElement("div", null, open(show), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: HyreTheme
  }, /*#__PURE__*/React.createElement(Dialog, {
    open: isShown,
    onClose: hide,
    "aria-labelledby": "form-dialog-title"
  }, /*#__PURE__*/React.createElement(Title, {
    id: "form-dialog-title"
  }, /*#__PURE__*/React.createElement(Header, {
    toDate: toDate,
    user: user,
    avatar: avatar
  }), /*#__PURE__*/React.createElement(IconButton, {
    onClick: hide
  }, /*#__PURE__*/React.createElement(Close, null))), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Tabs, {
    value: activeTab,
    indicatorColor: "primary",
    textColor: "primary",
    onChange: function onChange(_event, newValue) {
      setActiveTab(newValue);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    value: "Shift",
    label: "Shift"
  }), /*#__PURE__*/React.createElement(Tab, {
    value: "Details",
    label: "Details"
  })), /*#__PURE__*/React.createElement(TabPanel, {
    value: activeTab,
    index: "Shift"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Time (", hoursInShift, ' ', "Hours)"), /*#__PURE__*/React.createElement(TimePick, {
    hourState: [pickedHour, setPickedHour],
    minuteState: [pickedMinutes, setPickedMinutes]
  }), "-", ' ', /*#__PURE__*/React.createElement(TimePick, {
    hourState: [pickedEndHour, setPickedEndHour],
    minuteState: [pickedEndMinutes, setPickedEndMinutes]
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Position"), positionsUnAvailable() ? /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, "Please choose a department that has positions enabled for this staff member.") : /*#__PURE__*/React.createElement(PositionSelector, {
    value: position,
    onChange: function onChange(e) {
      return setPosition(e.target.value);
    },
    labelId: "position-selector-label"
  }, positions.map(function (pos) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: "".concat(pos.id, "-").concat(toDate, "-").concat(user.id),
      value: pos.id
    }, pos.name);
  }))), departments && departments.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Choose Department"), /*#__PURE__*/React.createElement(DepartmentSelector, {
    onChange: function onChange(e) {
      return setchosenDepartmentId(e.target.value);
    },
    value: chosenDepartmentId
  }, departments.map(function (dep) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: dep.id,
      value: dep.id
    }, dep.name);
  })))))), /*#__PURE__*/React.createElement(TabPanel, {
    value: activeTab,
    index: "Details"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    direction: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(AssignSelect, {
    assignState: [assign, setAssign]
  }))))), positionsUnAvailable() ? '' : /*#__PURE__*/React.createElement(SubmitActions, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      return handleSubmit({
        published: false
      });
    },
    fullWidth: true
  }, "Draft"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleSubmit({
        published: true
      });
    },
    disableElevation: true,
    fullWidth: true
  }, "Publish")))));
};

export { ShiftDialog };